import { snowCub, ventisquero } from '../models/ventisquero.ts';
import { arado } from '../models/arado.ts';
import { tallerModel } from '../models/taller.ts';
import { picotera } from '../models/cable.ts';
import { tenaza } from '../models/corazon.ts';
import { barrena } from '../models/ojos.ts';
import { ashCub } from '../models/tormo.ts';
import { ashSeal as cazaAshSeal, elderHowler as cazaElder, grayWolf as cazaGrayWolf, howler as cazaHowler } from '../models/caza.ts';
import { lapa } from '../models/camino.ts';
import { doliente, lengua } from '../models/ermita.ts';
import { bosqueModel } from '../models/bosque.ts';
import { sendaModel } from '../models/sendas.ts';
import { biblioModel } from '../models/biblio.ts';
import * as THREE from 'three';
import { GEAR_BASES, type GearBaseId, type HeroClass, type NpcId, type SeasonId, type UniqueId } from '@somnhold/content';
import * as bosses from '../models/bosses.ts';
import { DRAGON_FRAMES, dragon } from '../models/dragon.ts';
import { barrelCart, cart, npcModel, orlaFighter, uniqueItem } from '../models/saga.ts';
import { gearItem, type GearRarity } from '../models/gear.ts';
import * as clock from '../models/clockwork.ts';
import { GUARD_POSES, guard, hulk, type GuardPose } from '../models/guard.ts';
import * as learned from '../models/learned.ts';
import { CAT_POSES, barracksCat, type CatModel } from '../models/saberes.ts';
import { gateProps, mastiff, siftDust } from '../models/saberes2.ts';
import * as heroes from '../models/heroes.ts';
import * as nm from '../models/nightmares.ts';
import * as siege from '../models/siege.ts';
import { mourner } from '../models/mourner.ts';
import { slinger } from '../models/slinger.ts';
import { troll } from '../models/troll.ts';
import { prowler } from '../models/prowler.ts';
import { beetle } from '../models/beetle.ts';
import { mammoth } from '../models/mammoth.ts';
import { uro } from '../models/uro.ts';
import { drinker } from '../models/drinker.ts';
import { drowned } from '../models/drowned.ts';
import { lure, maw } from '../models/maw.ts';
import { sunken } from '../models/sunken.ts';
import { bannerman } from '../models/bannerman.ts';
import { bonesinger } from '../models/bonesinger.ts';
import { wyvern } from '../models/wyvern.ts';
import { moth } from '../models/moth.ts';
import { weaver } from '../models/weaver.ts';
import { spiderling } from '../models/spiderling.ts';
import { boneworm, leech, molten, puffball, rime, rootwight, scribe, shardling } from '../models/sima.ts';
import { dragger } from '../models/dragger.ts';
import { oracle } from '../models/oracle.ts';
import { wyrmling } from '../models/wyrmling.ts';
import { ogre } from '../models/ogre.ts';
import { crow } from '../models/crow.ts';
import { giant } from '../models/giant.ts';
import { sentinel } from '../models/sentinel.ts';
import { corvin } from '../models/corvin.ts';
import { kaela, kaelaBear } from '../models/kaela.ts';
import { lucan } from '../models/lucan.ts';
import { edda } from '../models/edda.ts';
import { vela } from '../models/vela.ts';
import { ansel } from '../models/ansel.ts';
import { bruni } from '../models/bruni.ts';
import { ragna } from '../models/ragna.ts';
import { frostColossus } from '../models/frost-colossus.ts';
import { stormHerald } from '../models/storm-herald.ts';
import { shellSerpent, shellSerpentBurrow } from '../models/shell-serpent.ts';
import { glassDrake } from '../models/glass-drake.ts';
import { shellback } from '../models/shellback.ts';
import { lidlessDreamer } from '../models/lidless-dreamer.ts';
import { leechMother } from '../models/leech-mother.ts';
import { cocoon, crystal, iceBlock } from '../models/sima-props.ts';
import { marrowWorm, marrowWormBurrowed } from '../models/marrow-worm.ts';
import { broodQueen } from '../models/brood-queen.ts';
import { bellows } from '../models/bellows.ts';
import { archivist } from '../models/archivist.ts';
import { prism } from '../models/prism.ts';
import { frostLady } from '../models/frost-lady.ts';
import { sporeMother } from '../models/spore-mother.ts';
import { rootking } from '../models/rootking.ts';
import { ashWatcher } from '../models/ash-watcher.ts';
import { calFace, prestado } from '../models/prestado.ts';
import * as items from '../models/items.ts';
import * as st from '../models/structures.ts';
import * as e2 from '../models/era2.ts';
import * as fort from '../models/fort.ts';
import * as up from '../models/upgrades.ts';
import { pumpkin } from '../models/seasonal.ts';
import { themeOf } from '../seasons/index.ts';
import type { Model, Pose } from '../models/types.ts';
import { heroTier, TIER_SCALE, type HeroTier } from '../models/hero-tiers.ts';
import { glowMat } from '../materials.ts';
import { bakeModel, type BakedModel, type BakeOptions, type ModelLike } from './bake.ts';
import { bakeAnim } from '../anim/atlas.ts';
import { collectMaterials, fromWire, toWire, type ModelWire } from './bake-wire.ts';
import { dressHero, parseLook } from '../models/dress.ts';
import { armero, parseArmero } from '../models/armero.ts';
import { panoplia, parsePanoplia } from '../models/panoplia.ts';
import { rehome, rigFor, type RigSpec } from '../anim/rigs.ts';
import { ModelBatch } from './batch.ts';
import { SCALE, WORLD_PER_HEX } from './coords.ts';
import { plinthModel } from './landmesh.ts';
import type { GlowLayer } from './glow.ts';
import { farModel, LOD } from './lod.ts';

const POSES = heroes.POSE_NAMES;
/** Spectres glow in the class's light (the default sea-green otherwise). */
const GHOST_TINT: Partial<Record<HeroClass | 'bear', string>> = { paladin: '#dfe8ff', druid: '#b3f59a', bear: '#b3f59a' };
const DYNAMIC = ['turret', 'arm', 'bell', 'crystal', 'portcullis', 'crew', 'spin'];
const HEROES: Record<HeroClass, (o?: heroes.HeroOpts) => Model> = {
  warrior: heroes.warrior,
  artificer: heroes.artificer,
  mage: heroes.mage,
  ranger: heroes.ranger,
  cleric: heroes.cleric,
  barbarian: heroes.barbarian,
  paladin: heroes.paladin,
  druid: heroes.druid,
};

interface Recipe {
  build: () => Model;
  bake: BakeOptions;
  scale: number;
  /** Rigged: the skeleton and clips to bake with (GPU-skinned, see anim/). */
  rig?: (m: Model) => RigSpec | null;
}

const tickFrames = (n: number): BakeOptions['frames'] => Array.from({ length: n }, (_, i) => (m) => m.tick(i + 1));

/** Ink (grade 2) look for nightmares that have no bespoke tiers: glossy near-black that drips. */
const inkify = (m: Model): Model => {
  const cache = new Map<THREE.Material, THREE.Material>();
  m.root.traverse((o) => {
    const mesh = o as THREE.Mesh;
    if (!mesh.isMesh) return;
    const src = mesh.material as THREE.MeshStandardMaterial;
    if (!src.isMeshStandardMaterial || (src.emissiveIntensity > 0.2 && src.emissive.getHex() !== 0)) return;
    let next = cache.get(src);
    if (!next) {
      const c = src.clone();
      c.color.lerp(new THREE.Color('#07060c'), 0.85);
      c.roughness = 0.08;
      c.metalness = 0.5;
      c.opacity = Math.max(c.opacity, 0.92);
      next = c;
      cache.set(src, c);
    }
    mesh.material = next;
  });
  return m;
};

/** Era IV's nightmares keep their own materials at any grade (see the ink rule in `recipe`). */
const ERA4_OWN = new Set(['corvin', 'kaela', 'kaelaBear', 'sentinel', 'frostColossus', 'stormHerald', 'shellSerpent', 'shellSerpentBurrow', 'lucan', 'edda', 'vela', 'ansel', 'bruni', 'ragna']);

/**
 * Era IV's sizes on the board: the sentinel half again a hero's height, the colossus a little over the sleeping
 * giant, the herald's cloud as wide as a tower's top, the serpent rearing over the wall it came up behind.
 */
const ERA4_SCALE: Record<string, number> = {
  sentinel: SCALE.enemy * 1.42,
  // The Unsleeping (docs/ANTIHEROES.md): Ser Corvin towers over the sentinels he once commanded.
  corvin: SCALE.enemy * 1.62,
  // Kaela of the Moss, and the bear she turns into from 33 %.
  kaela: SCALE.enemy * 1.62,
  kaelaBear: SCALE.enemy * 1.25,
  lucan: SCALE.enemy * 1.62,
  edda: SCALE.enemy * 1.62,
  vela: SCALE.enemy * 1.62,
  ansel: SCALE.enemy * 1.62,
  bruni: SCALE.enemy * 1.62,
  ragna: SCALE.enemy * 1.62,
  frostColossus: SCALE.boss * 1.5,
  stormHerald: SCALE.enemy * 1.8,
  shellSerpent: SCALE.enemy * 1.5,
  shellSerpentBurrow: SCALE.enemy * 2.0,
};

/**
 * The Chasm's guardians (docs/SIMA.md «Guardianes») and the props struck like nightmares: their own materials at
 * any grade, and their sizes on the board. The guardians stand as big as the magma lord or more (the wide ones
 * longer than they are tall); the crystal a little over a hero, the cocoon knee-high, the ice a hero's height.
 */
export const SIMA_GUARDIANS: ReadonlySet<string> = new Set(['leechMother', 'rootking', 'sporeMother', 'frostLady', 'prism', 'archivist', 'bellows', 'broodQueen', 'marrowWorm', 'marrowWormBurrowed']);

/**
 * La Sima's own nightmares keep their materials at any grade too (each wears its stratum's colour, so a floor reads at
 * a glance: everything in SIMA_SCALE stays out of the ink). Their sizes on the board: the swarms (leeches, bone gnawers) small at a hero's feet, the scarecrow and the
 * molten over a hero's head, the scribe as tall as one and too thin; then the guardians and their props.
 */
const SIMA_SCALE: Record<string, number> = {
  leech: SCALE.enemy * 1.1,
  boneworm: SCALE.enemy * 1.0,
  puffball: SCALE.enemy * 1.05,
  rime: SCALE.enemy * 1.1,
  shardling: SCALE.enemy * 1.1,
  scribe: SCALE.enemy * 1.0,
  rootwight: SCALE.enemy * 1.1,
  molten: SCALE.enemy * 1.1,
  leechMother: SCALE.boss * 1.55,
  crystal: SCALE.enemy * 1.4,
  cocoon: SCALE.enemy * 1.3,
  // Built at a hero's size (a hero is ~1.8 model units): a little taller and wider than the one inside.
  iceBlock: SCALE.hero * 1.05,
  marrowWorm: SCALE.boss * 1.5,
  marrowWormBurrowed: SCALE.boss * 1.5,
  broodQueen: SCALE.boss * 1.5,
  bellows: SCALE.boss * 1.55,
  archivist: SCALE.boss * 1.45,
  prism: SCALE.boss * 1.45,
  frostLady: SCALE.boss * 1.35,
  sporeMother: SCALE.boss * 1.5,
  rootking: SCALE.boss * 1.5,
};

/** Era V's nightmares keep their own materials at any grade too (their glass, shell, sheets and ash). */
const ERA5_OWN = new Set(['glassDrake', 'shellback', 'lidlessDreamer', 'lidlessDreamerAwake', 'ashWatcher']);

/**
 * Era V's sizes on the board, bigger than era IV's: the drake's wings as wide as the frost colossus is tall, the
 * shellback two hexes long (the biggest of the common nightmares), the dreamer and the watcher towering over a hero.
 */
const ERA5_SCALE: Record<string, number> = {
  glassDrake: SCALE.boss * 0.8,
  shellback: SCALE.boss * 0.85,
  lidlessDreamer: SCALE.enemy * 1.4,
  lidlessDreamerAwake: SCALE.enemy * 1.4,
  ashWatcher: SCALE.enemy * 1.3,
  // Taller than a man and far too thin: it towers over the crowd it hid in.
  prestado: SCALE.enemy * 1.05,
  // The Prestacaras in Cal's face: a man's size (the boss scale comes on top where it is drawn).
  calFace: SCALE.hero,
};

const wearOf = (v: string | undefined): st.Wear => (v === '2' ? 2 : v === '1' ? 1 : 0);

/** Model-to-world scale of a structure type (level 1). The gatehouse is modeled at world size (one hex wide) to meet the rampart runs exactly. */
const structScale = (t: string): number =>
  // The Titan's Eye is modelled at world size: its ring of plinths stands one hex out, on the six cells round it.
  t === 'gate' || t === 'rampart' || t === 'titanEye' ? 1 : t === 'wall' ? SCALE.wall : t === 'spikes' || t === 'oil' ? SCALE.trap : t === 'forge' || t === 'barracks' || t === 'temple' || t === 'workshop' || t === 'lab' || t === 'grove' || t === 'hall' || t === 'sanctum' || t === 'depot' || t === 'golemworks' || t === 'foundry' || t === 'arsenal' || t === 'market' || t === 'kennel' || t === 'sieve' ? SCALE.support : t === 'boulder' ? SCALE.trap : t === 'watchtower' ? SCALE.support * 1.15 : SCALE.tower;

const SOOT = new THREE.Color('#1e1b18');
const WEATHERED = new Map<string, THREE.Material>();

/**
 * Darkens a worn structure's stone and timber a little (stage 2 more), so the stage reads from the far
 * table camera on top of its cracks and breaks. Lit parts (crystals, fire, runes), see-through ones and
 * the crew are left as they are.
 */
const weather = (m: Model, wear: st.Wear): Model => {
  if (wear === 0) return m;
  const walk = (o: THREE.Object3D): void => {
    if (o.userData.part === 'crew') return;
    const mesh = o as THREE.Mesh;
    const src = mesh.material as THREE.MeshStandardMaterial | undefined;
    if (mesh.isMesh && src?.isMeshStandardMaterial && !src.transparent && !(src.emissiveIntensity > 0.2 && src.emissive.getHex() !== 0)) {
      const k = `${src.uuid}:${wear}`;
      let next = WEATHERED.get(k);
      if (!next) {
        const c = src.clone();
        c.color.lerp(SOOT, wear === 2 ? 0.4 : 0.22);
        next = c;
        WEATHERED.set(k, c);
      }
      mesh.material = next;
    }
    for (const ch of o.children) walk(ch);
  };
  walk(m.root);
  return m;
};

/**
 * Library key of a standing structure: `struct:type:level:material[:wear][:branch]` (a branch without wear writes
 * wear 0). The engine draws, bakes ahead and bakes late with this one key, so a branch's worn and crumbling
 * variants bake before the fight like any other.
 */
export const structKey = (type: string, level: number, material: number, wear: number | string = 0, branch?: string): string =>
  `struct:${type}:${level}:${material}${wear === 1 || wear === 2 || branch ? `:${wear === 1 || wear === 2 ? wear : 0}` : ''}${branch ? `:${branch}` : ''}`;

const recipe = (key: string): Recipe => {
  const [kind, a, b, c, d, e] = key.split(':');
  switch (kind) {
    // `rig:<key>`: the same model rigged and animated on the GPU (one rest frame for heroes; nightmares keep their boil).
    case 'rig': {
      const innerKey = key.slice(4);
      const inner = recipe(innerKey);
      // Heroes and the artificer's and builders' clockwork move only by their bones: one frame. Nightmares keep their boil frames.
      const still = a === 'hero' || a === 'golem' || (a === 'bot' && b !== 'cart' && b !== 'barrelCart' && b !== 'spider' && b !== 'mastiff');
      // The dragon's wing beat is in its bones now: four boil frames like any nightmare.
      const dragonBoil = a === 'enemy' && (b === 'dragon' || b === 'dragonAir');
      return { ...inner, bake: still ? { frames: [() => undefined] } : dragonBoil ? { frames: tickFrames(4) } : inner.bake, rig: (m) => rigFor(innerKey, m) };
    }
    // `hero:cls:ghost[:tier]` (see heroKey); `cls` is 'bear' for a druid in bear form.
    case 'hero': {
      const cls = a as HeroClass | 'bear';
      const ghost = b === '1';
      const tier = Math.min(4, Math.max(1, Number(c) || 1)) as HeroTier;
      return {
        build: () => {
          const tint = GHOST_TINT[cls] ?? '#7fe3d6';
          const m = (cls === 'bear' ? heroes.bear : (HEROES[cls] ?? heroes.warrior))(ghost ? { ghost: tint, tier } : { tier });
          // `hero:cls:ghost:tier:look`: dressed in what it wears (docs/EQUIPO.md §10).
          const look = cls === 'bear' ? null : parseLook(d);
          if (look && cls !== 'bear') dressHero(m, cls, look, ghost ? tint : undefined);
          return m;
        },
        bake: { frames: POSES.map((p) => (m: Model) => (m.rig ? heroes.applyPose(m.rig, p) : undefined)) },
        scale: SCALE.hero * TIER_SCALE[tier],
      };
    }
    // `enemy:kind:tier:elite[:season]`: a season with a theme dresses its nightmares (a variant of their own).
    case 'enemy': {
      const tier = Number(b) as 1 | 2 | 3;
      const elite = c === '1';
      const dress = themeOf(d as SeasonId | undefined)?.dressEnemy;
      const big = a === 'dragon' || a === 'dragonAir';
      // The dragon's wing beat and breathing run over eight frames.
      const frames = { frames: tickFrames(big ? DRAGON_FRAMES : 4) };
      const glassGiant = a === 'colossus' || a === 'colossusShine';
      const boss = a === 'witch' || a === 'shell' || a === 'warden' || a === 'wardenEmber' || a === 'magmaLord' || glassGiant || big;
      const make = (): Model => {
        switch (a) {
          case 'goblin':
            return nm.goblin({ tier, elite });
          case 'wolf':
            return nm.wolf({});
          case 'skeleton':
            return nm.skeleton({});
          case 'wraith':
            return nm.wraith({});
          case 'gargoyle':
            return nm.gargoyle({});
          case 'slime':
            return nm.slime({});
          case 'stalker':
            return nm.stalker({});
          case 'sapper':
            return siege.sapper({});
          case 'ram':
            return siege.ram({});
          case 'mangonel':
            return siege.mangonel({});
          case 'archer':
            return siege.archer({});
          // Era II's siege beast: the ash mammoth, the biggest of the regular nightmares.
          case 'mammoth':
            return mammoth({});
          // El Cuerno 3: the Old Uro, the bull of ash that hunts the clan's herd.
          case 'uro':
            return uro({});
          // Las vías 4: the biggest automaton Bruni turned (when he already fell elsewhere).
          case 'hulk':
            return hulk({});
          // El pozo 2: the Drinker, empty, and swollen with the water it drank (`drinkerFull`, a variant of its own).
          case 'drinker':
            return drinker({});
          case 'drinkerFull':
            return drinker({ full: true });
          // La Orilla: the Drowned, a bloated fisherman the sea kept (the troll's rig).
          case 'drowned':
            return drowned({});
          // La Orilla 3: the Maw at the water's edge (still and dim while its light is broken: `mawDark`), and its light.
          case 'maw':
            return maw({});
          case 'mawDark':
            return maw({ dark: true });
          case 'lure':
            return lure({});
          // La Orilla 5: the Drowned Dragon, its chest on fire, or steaming with its heart gone to the forge (`sunkenSteam`).
          case 'sunken':
            return sunken({});
          case 'sunkenSteam':
            return sunken({ steam: true });
          // New creatures (docs/CRIATURAS.md): the mourner, the shadow ogre, the soot crow and the sleeping giant.
          case 'troll':
            return troll({});
          // The Furrows' prowler (docs/LABERINTOS.md): shell stone that never falls.
          case 'prowler':
            return prowler({});
          case 'beetle':
            return beetle({});
          // The beetle with its shell split open (a heavy blow cracked it): a variant of its own.
          case 'beetleCracked':
            return beetle({ cracked: true });
          case 'bannerman':
            return bannerman({});
          case 'bonesinger':
            return bonesinger({});
          case 'wyvern':
            return wyvern({});
          case 'moth':
            return moth({});
          case 'weaver':
            return weaver({});
          case 'spiderling':
            return spiderling({});
          // La Sima (docs/SIMA.md «Criaturas nuevas»): one per new stratum.
          case 'leech':
            return leech({});
          case 'rootwight':
            return rootwight({});
          case 'puffball':
            return puffball({});
          case 'rime':
            return rime({});
          case 'shardling':
            return shardling({});
          case 'scribe':
            return scribe({});
          case 'molten':
            return molten({});
          case 'boneworm':
            return boneworm({});
          case 'dragger':
            return dragger({});
          case 'oracle':
            return oracle({});
          case 'wyrmling':
            return wyrmling({});
          case 'slinger':
            return slinger({});
          case 'mourner':
            return mourner({});
          case 'ogre':
            return ogre({});
          case 'crow':
            return crow({});
          case 'giant':
            return giant({});
          // Awake (below half its health): eyes open, embers in the cracks — a variant of its own.
          case 'giantAwake':
            return giant({ awake: true });
          // Era IV, the Vigil's bastion (docs/CRIATURAS.md): the fallen sentinel, the frost colossus, the storm
          // herald and the shell serpent (underground, `shellSerpentBurrow`, only a mound of earth).
          case 'sentinel':
            return sentinel({});
          case 'corvin':
            return corvin({});
          case 'kaela':
            return kaela({});
          case 'kaelaBear':
            return kaelaBear({});
          case 'lucan':
            return lucan({});
          case 'edda':
            return edda({});
          case 'vela':
            return vela({});
          case 'ansel':
            return ansel({});
          case 'bruni':
            return bruni({});
          case 'ragna':
            return ragna({});
          case 'frostColossus':
            return frostColossus({});
          case 'stormHerald':
            return stormHerald({});
          case 'shellSerpent':
            return shellSerpent({});
          case 'shellSerpentBurrow':
            return shellSerpentBurrow({});
          // Era V, Somnhold (docs/CRIATURAS.md): the glass drake, the shellback, the lidless dreamer (its crown
          // open, `lidlessDreamerAwake`, a look of its own) and the ash watcher.
          case 'glassDrake':
            return glassDrake({});
          case 'shellback':
            return shellback({});
          case 'lidlessDreamer':
            return lidlessDreamer({});
          case 'lidlessDreamerAwake':
            return lidlessDreamer({ awake: true });
          case 'ashWatcher':
            return ashWatcher({});
          // The Chasm's guardians and props (docs/SIMA.md).
          case 'leechMother':
            return leechMother({});
          case 'crystal':
            return crystal({});
          case 'cocoon':
            return cocoon({});
          case 'iceBlock':
            return iceBlock({});
          case 'marrowWorm':
            return marrowWorm({});
          // While it runs under the floor: only the mound (a variant of its own).
          case 'marrowWormBurrowed':
            return marrowWormBurrowed({});
          case 'broodQueen':
            return broodQueen({});
          case 'bellows':
            return bellows({});
          case 'archivist':
            return archivist({});
          case 'prism':
            return prism({});
          case 'frostLady':
            return frostLady({});
          case 'sporeMother':
            return sporeMother({});
          case 'rootking':
            return rootking({});
          // Caras prestadas: what is under a borrowed face.
          case 'prestado':
            return prestado({});
          // The Prestacaras wearing Cal's face (nobody absent to copy).
          case 'calFace':
            return calFace({});
          case 'witch':
            return bosses.witch({});
          case 'shell':
            return bosses.shell({});
          case 'warden':
            return bosses.warden({});
          // The Warden of the crypt in embers (level II): charred bone split by seams of fire.
          case 'wardenEmber':
            return bosses.warden({ molten: true });
          case 'magmaLord':
            return bosses.magmaLord({});
          // The obsidian colossus (level III), and shining (it turns blows back): a variant of its own.
          case 'colossus':
            return bosses.obsidianColossus({});
          case 'colossusShine':
            return bosses.obsidianColossus({ shining: true });
          // The dragon of the Burn: landed, and on the wing (`dragonAir`, a variant of its own).
          case 'dragon':
            return dragon({});
          case 'dragonAir':
            return dragon({ flying: true });
          case 'boneWall':
            return nm.boneWall({});
          case 'pumpkin':
            return pumpkin({});
          // The warrior's path, chapter 5 (models/ventisquero.ts): the Ventisquero and its cubs (a giant's and a goblin's
          // place in the fight, their own look).
          case 'ventisquero':
            return ventisquero({});
          case 'snowCub':
            return snowCub({});
          // The paladin's path, chapter 1 (models/arado.ts): the Arado, an ogre's place in the fight, its own look.
          case 'arado':
            return arado({});
          // The mage's path, chapter 1 (models/biblio.ts): the loose pages, soot crows in the fight.
          case 'page':
            return biblioModel('page') as Model;
          // The artificer's path, chapter 1 (models/taller.ts): Nadd's old golems and the Overseer, ogres in the fight.
          case 'workGolem':
          case 'capataz':
            return tallerModel(a, {}) as Model;
          // The artificer's path, chapter 2 (models/cable.ts): La Picotera, a gargoyle in the fight, its own look.
          case 'picotera':
            return picotera({});
          // The artificer's path, chapter 3 (models/corazon.ts): La Tenaza, an ogre in the fight, its own look.
          case 'tenaza':
            return tenaza({});
          // The artificer's path, chapter 4 (models/ojos.ts): La Barrena, an ogre in the fight, its own look.
          case 'barrena':
            return barrena({});
          // The artificer's path, chapter 5 (models/tormo.ts): the ash cubs of the shell and the plates (goblins in the fight).
          case 'ashCub':
            return ashCub({});
          // The barbarian's path, chapter 1 (models/caza.ts): the howler (a wolf in the fight) and the Grey Wolf.
          case 'howler':
            return cazaHowler({});
          case 'grayWolf':
            return cazaGrayWolf({});
          // Chapter 5: the cubs of the den, a wolf small and pale-tipped.
          case 'wolfCub':
            return nm.wolf({});
          // Chapter 3: the old howler, grizzled.
          case 'elderHowler':
            return cazaElder({});
          // Chapter 4: the Ash Seal on Sigrun's last night.
          case 'ashSeal':
            return cazaAshSeal({});
          // The cleric's path, chapter 1 (models/camino.ts): the limpets of ink, draggers in the fight.
          case 'lapa':
            return lapa({});
          // Its chapter 4 (models/ermita.ts): the Doliente (a wraith in the sim) and her tongues of ink (draggers).
          case 'doliente':
            return doliente({});
          case 'lengua':
            return lengua({});
          // The druid's path, chapter 1 (models/bosque.ts): the Lodazal (a drowned in the sim); the clearing's slimes
          // swollen with the shoots they ate (`slimeFat`, `slimeFat2`: the slime, bigger).
          case 'lodazal':
            return bosqueModel('lodazal') as Model;
          case 'slimeFat':
          case 'slimeFat2':
            return nm.slime({});
          // The druid's path, chapter 2: the old wyvern of the counterfire (an ash wyvern, bigger).
          case 'wyvernOld':
            return wyvern({});
          // The druid's path, chapter 3: the broodmother of the test (a weaver, far bigger).
          case 'broodmother':
            return weaver({});
          // The druid's path, chapter 4: the frost that climbs (a rime, far bigger).
          case 'escarcha':
            return rime({});
          // The druid's path, chapter 5 (models/sendas.ts): the Carcoma (a drowned in the sim), her own look.
          case 'carcoma':
            return sendaModel('carcoma');
          // The paladin's path, chapter 5 (models/sendas.ts): La Que Huyó (a drowned in the sim) and her squires (goblins).
          case 'fledBoss':
            return sendaModel('fledBoss');
          case 'fledSquire':
            return sendaModel('fledSquire');
          default:
            return nm.goblin({ tier: 1 });
        }
      };
      return {
        build: () => {
          const m = make();
          // The giant keeps its stone at any grade (ink would lose the titan's shell it was dreamt from), the bannerman its pale sigil.
          // Era IV's keep their own too: the sentinel the Order's crimson and steel, the colossus its ice, the herald its
          // storm (ink would make its cloud solid) and the serpent the shell's plates.
          if (a !== 'goblin' && a !== 'prowler' && a !== 'uro' && a !== 'hulk' && a !== 'drinker' && a !== 'drinkerFull' && a !== 'drowned' && a !== 'maw' && a !== 'mawDark' && a !== 'lure' && a !== 'sunken' && a !== 'sunkenSteam' && tier >= 2 && !boss && a !== 'boneWall' && a !== 'pumpkin' && a !== 'giant' && a !== 'giantAwake' && a !== 'ventisquero' && a !== 'snowCub' && a !== 'ashCub' && a !== 'lodazal' && a !== 'arado' && a !== 'fledBoss' && a !== 'fledSquire' && a !== 'bannerman' && !ERA4_OWN.has(a as string) && !ERA5_OWN.has(a as string) && !SIMA_SCALE[a as string]) inkify(m);
          if (dress) {
            // What the dress adds to a rigged model rides the bone it sits on.
            const g = m.root.getObjectByName('model') ?? m.root;
            const before = new Set(g.children);
            dress(a as string, m, { tier, elite });
            rehome(m, g.children.filter((ch) => !before.has(ch)));
          }
          if (elite && a !== 'goblin') m.root.scale.setScalar(1.2);
          return m;
        },
        bake: frames,
        // The dragon is the biggest thing on any board: five hexes nose to tail landed, more across the wings.
        scale: ERA4_SCALE[a as string] ?? ERA5_SCALE[a as string] ?? SIMA_SCALE[a as string] ?? (big ? SCALE.boss * DRAGON_SCALE : a === 'magmaLord' ? SCALE.boss * 2.1 : glassGiant ? SCALE.boss * 2.2 : a === 'warden' || a === 'wardenEmber' ? SCALE.boss * 1.45 : boss ? SCALE.boss : a === 'boneWall' ? 0.9 : a === 'giant' || a === 'giantAwake' ? SCALE.boss * 1.6 : a === 'ventisquero' ? SCALE.boss * 1.75 : a === 'snowCub' ? SCALE.enemy * 0.95 : a === 'arado' ? SCALE.enemy * 1.7 : a === 'workGolem' ? SCALE.enemy * 1.25 : a === 'capataz' ? SCALE.enemy * 1.6 : a === 'lodazal' ? SCALE.boss * 1.35 : a === 'slimeFat' ? SCALE.enemy * 1.3 : a === 'slimeFat2' ? SCALE.enemy * 1.65 : a === 'wyvernOld' ? SCALE.enemy * 2.1 : a === 'broodmother' ? SCALE.enemy * 2.3 : a === 'escarcha' ? SCALE.enemy * 2.4 : a === 'carcoma' ? SCALE.enemy * 3.4 : a === 'picotera' ? SCALE.enemy * 2.1 : a === 'tenaza' ? SCALE.enemy * 2.3 : a === 'barrena' ? SCALE.enemy * 1.7 : a === 'ashCub' ? SCALE.enemy * 1.0 : a === 'howler' ? SCALE.enemy * 1.55 : a === 'grayWolf' ? SCALE.enemy * 3.6 : a === 'wolfCub' ? SCALE.enemy * 0.68 : a === 'elderHowler' ? SCALE.enemy * 1.95 : a === 'ashSeal' ? SCALE.enemy * 2.7 : a === 'lapa' ? SCALE.enemy : a === 'doliente' ? SCALE.enemy * 1.55 : a === 'lengua' ? SCALE.enemy * 0.95 : a === 'fledBoss' ? SCALE.hero * 1.42 : a === 'fledSquire' ? SCALE.hero * 0.74 : a === 'mammoth' ? SCALE.enemy * 1.25 : a === 'uro' ? SCALE.enemy * 1.55 : a === 'hulk' ? SCALE.boss * 1.5 : a === 'drinker' || a === 'drinkerFull' ? SCALE.boss * 0.95 : a === 'maw' || a === 'mawDark' ? SCALE.boss * 1.7 : a === 'sunken' || a === 'sunkenSteam' ? SCALE.boss * 0.95 : a === 'lure' ? SCALE.enemy * 1.15 : a === 'ogre' ? SCALE.enemy * 1.3 : a === 'prowler' ? SCALE.enemy * 1.55 : a === 'drowned' ? SCALE.enemy * 1.25 : a === 'troll' || a === 'bannerman' ? SCALE.enemy * 1.15 : a === 'bonesinger' ? SCALE.enemy * 1.06 : a === 'oracle' ? SCALE.enemy * 1.05 : a === 'weaver' ? SCALE.enemy * 1.25 : a === 'spiderling' ? SCALE.enemy * 0.8 : a === 'dragger' ? SCALE.enemy * 0.85 : a === 'wyrmling' ? SCALE.enemy * 1.2 : a === 'wyvern' || a === 'beetle' || a === 'beetleCracked' ? SCALE.enemy * 1.25 : SCALE.enemy),
      };
    }
    // `struct:type:level:material[:wear][:branch]` (level 1–6: towers and the forge to 6; material 1 wood · 2 stone ·
    // 3 iron; wear 1 worn, 2 crumbling; a tower's branch, content BRANCHES). See structKey.
    case 'struct': {
      const level = Math.min(6, Math.max(1, Number(b) || 1)) as up.StructLevel;
      const material = Math.min(3, Math.max(1, Number(c) || 1)) as up.StructMaterial;
      const wear = wearOf(d);
      const t = a as string;
      const scale = structScale(t);
      const tower = up.TOWER_TYPES.includes(t);
      return {
        build: () => weather(up.structure(t, level, material, wear, WORLD_PER_HEX, e || undefined), wear),
        bake: { frames: [(m) => m.tick(0)], dynamic: DYNAMIC },
        // Each level stands a little taller, so an upgrade reads at a glance from the table.
        scale: tower ? scale * (1 + 0.08 * (level - 1)) : scale,
      };
    }
    // `ruin:type:material`: what a destroyed structure leaves, at the structure's own scale.
    case 'ruin':
      return { build: () => up.ruinModel(a as string, Number(b)), bake: { frames: [(m) => m.tick(0)] }, scale: structScale(a as string) };
    // `cat`: the barracks cat (docs/SABERES.md §4.5), one baked frame per pose (CAT_POSES); her kittens are the same,
    // smaller. Bigger than life next to a hero, as a miniature's pet is: she has to read from the table camera.
    case 'cat':
      return { build: () => barracksCat({}), bake: { frames: CAT_POSES.map((p) => (m: Model) => (m as CatModel).pose(p)) }, scale: SCALE.hero * 1.2 };
    // The props braced inside a gate (the rite, docs/SABERES.md §4.3), and the sieve's catch waiting to be sifted.
    case 'gateProps':
      return { build: () => gateProps({}), bake: { frames: [(m) => m.tick(0)] }, scale: 1 };
    case 'siftDust':
      return { build: () => siftDust({}), bake: { frames: [(m) => m.tick(0)] }, scale: SCALE.support };
    case 'keep':
      // `keep:era`: the keep grows a stage with each era of the bastion.
      return { build: () => st.keep({ era: Number(a) || 1 }), bake: { frames: [(m) => m.tick(0)] }, scale: SCALE.keep };
    // `turret[:vigil]`: the portable turret; `vigil`, the first Vigil's ballista (the dragon's fight, La Quemadura done).
    case 'turret':
      return { build: () => st.turret({ vigil: a === 'vigil' }), bake: { frames: [(m) => m.tick(0)], dynamic: ['turret'] }, scale: SCALE.turret };
    case 'rampart':
      return { build: () => st.wall({ material: 2 }), bake: { frames: [(m) => m.tick(0)] }, scale: 1 };
    // Ring pieces: `curtain:full|half[:wear]`, `rampartTower:big|small[:wear]` (wear 1 worn, 2 crumbling).
    // `fullTitan`/`halfTitan`: the era V ring, of the titan's stone with its shell plates and runes.
    case 'curtain':
      return { build: () => weather(st.curtain({ length: (a ?? '').startsWith('half') ? WORLD_PER_HEX / 2 : WORLD_PER_HEX, wear: wearOf(b), titan: (a ?? '').endsWith('Titan') }), wearOf(b)), bake: { frames: [(m) => m.tick(0)] }, scale: 1 };
    case 'rampartTower':
      // `bigVigil`/`smallVigil`: the era IV ring, the Order's standards and the Vigil's flame on its towers;
      // `bigTitan`/`smallTitan`: era V's, the titan's stone and a shard of the Dream Beacon on every tower.
      return {
        build: () => weather(st.rampartTower({ big: (a ?? '').startsWith('big'), vigil: (a ?? '').endsWith('Vigil'), titan: (a ?? '').endsWith('Titan'), wear: wearOf(b) }), wearOf(b)),
        bake: { frames: [(m) => m.tick(0)] },
        scale: 1,
      };
    // The artificer's clockwork: `bot:automaton|colossus|spider`, and the gear grenade on the ground.
    case 'bot': {
      // The saga's caravan: a wagon a golem pushes (wheels turn and the golem strides over four frames).
      if (a === 'cart') return { build: () => cart({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero * 1.15 };
      // Brann's bet «El barril»: the same wagon with the garrison's cask on it.
      // A third bigger than the caravan: the barrel is the whole bet, it has to read at the game camera.
      if (a === 'barrelCart') return { build: () => barrelCart({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero * 1.5 };
      // Las vías 2: Dorn's guard automaton (bone and stone, lit red), posed in frames; its last frame is wound down.
      if (a === 'guard') return { build: () => guard({}), bake: { frames: GUARD_POSES.map((p) => (m: Model) => (m as ReturnType<typeof guard>).pose(p)) }, scale: SCALE.hero * 1.2 };
      // Las vías 4: Dorn's own, lit his blue-green (the same frames).
      if (a === 'guardDorn') return { build: () => guard({ friend: true }), bake: { frames: GUARD_POSES.map((p) => (m: Model) => (m as ReturnType<typeof guard>).pose(p)) }, scale: SCALE.hero * 1.2 };
      if (a === 'spider') return { build: () => clock.spiderBot({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero * 1.15 };
      // The learned skills' companions: the warrior's decoy and the ranger's hawk.
      if (a === 'decoy') return { build: () => learned.decoy({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero };
      if (a === 'drone') return { build: () => learned.drone({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero * 0.8 };
      if (a === 'hawk') return { build: () => learned.hawk({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero * 0.9 };
      if (a === 'hound') return { build: () => learned.hound({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero };
      // The kennel's mastiffs (docs/SABERES.md §4.1): a big war dog, its trot in four baked frames (kept when rigged).
      if (a === 'mastiff') return { build: () => mastiff({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero * 1.25 };
      if (a === 'treant') return { build: () => learned.treant({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero };
      // The unique forms' own (docs/UNICAS.md §3): the old bark bear, the empty cloak, the garrison's spectre and Ser Gaspar.
      if (a === 'barkBear') return { build: () => learned.barkBear({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero };
      // The druid's panoply (docs/PANOPLIA.md §10): the goatherd's pelt's shadow wolves.
      if (a === 'shadeWolf') return { build: () => learned.shadeWolf({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero };
      if (a === 'cloak') return { build: () => learned.cloak({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero };
      if (a === 'gasparGuard') return { build: () => learned.gasparGuard({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero };
      if (a === 'gaspar') return { build: () => learned.gasparGuard({ gaspar: true }), bake: { frames: tickFrames(4) }, scale: SCALE.hero * 1.15 };
      const big = a === 'colossus';
      return {
        build: () => (big ? clock.colossus({}) : clock.automaton({})),
        bake: { frames: clock.BOT_POSES.map((p, i) => (m: Model) => { m.tick(i * 3); (m as clock.BotModel).pose(p); }) },
        // The automaton stands a head and a half over a hero; the colossus twice its bulk.
        scale: big ? SCALE.hero * 1.25 : SCALE.hero,
      };
    }
    // `senda:<model>`: a path's own person (models/sendas.ts), rigged with the folk's clips (walk, dig, sit, kneel).
    case 'senda':
      return { build: () => sendaModel(a as string), bake: { frames: POSES.map((p) => (m: Model) => (m.rig ? heroes.applyPose(m.rig, p) : undefined)) }, scale: SCALE.hero };
    // `npc:<id>`: a person of the saga, for the scenes' portraits (see renderPortrait).
    case 'npc':
      return { build: () => npcModel(a as NpcId), bake: { frames: [(m) => m.tick(0)] }, scale: SCALE.hero };
    // `ally:<npc>`: a person of the sagas fighting at the heroes' side, posed like a hero, alive (not a spectre): Orla
    // with her bow (the dragon's fight, La Quemadura done), and everyone who comes to the night of the bell (El Párpado 4).
    case 'ally':
      return { build: () => (a === 'orla' ? orlaFighter() : npcModel(a as NpcId)), bake: { frames: POSES.map((p) => (m: Model) => (m.rig ? heroes.applyPose(m.rig, p) : undefined)) }, scale: SCALE.hero };
    // `armero:<base.rarity,…>`: the armory's rack by the forge, with the group's best finds (docs/EQUIPO.md §6).
    case 'armero':
      return { build: () => armero(parseArmero(key.slice('armero:'.length))), bake: { frames: [(m) => m.tick(0)] }, scale: SCALE.hero * 1.35 };
    // `panoplia:<id.stage,…>|<held>/<total>`: the old barracks' panoply over the rack, the group's rearmed pieces (docs/PANOPLIA.md §9.6).
    case 'panoplia':
      return { build: () => panoplia(parsePanoplia(key.slice('panoplia:'.length))), bake: { frames: [(m) => m.tick(0)] }, scale: SCALE.hero * 1.35 };
    // `unique:<id>`: one of the 24 unique pieces, for its card.
    case 'unique':
      return { build: () => uniqueItem({ id: a as UniqueId }), bake: { frames: [(m) => m.tick(0)] }, scale: 1 };
    // `gear:<base>:<rarity>`: one of the 44 gear bases at a rarity, for its card.
    case 'gear':
      return { build: () => gearItem({ gear: a as GearBaseId, rarity: (b ?? 'common') as GearRarity }), bake: { frames: [(m) => m.tick(0)] }, scale: 1 };
    // The warrior's guard banner, driven into the ground.
    case 'banner':
      return { build: () => learned.banner({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero };
    // The cleric's guard totem, standing where it was planted.
    case 'totem':
      return { build: () => learned.totem({}), bake: { frames: tickFrames(4) }, scale: SCALE.hero };
    case 'grenade':
      return { build: () => clock.gearGrenade({}), bake: { frames: tickFrames(4) }, scale: 0.95 };
    case 'golem':
      return { build: () => heroes.golem({ variant: (Number(a) % 4) as 0 | 1 | 2 | 3 }), bake: { frames: tickFrames(2) }, scale: SCALE.golem };
    case 'rampartRubble':
      return { build: () => st.rampartRubble({}), bake: { frames: [(m) => m.tick(0)] }, scale: 1 };
    case 'rubble':
      return { build: rubble, bake: { frames: [() => undefined] }, scale: 1 };
    case 'node':
      return { build: () => nodePiece(a as string), bake: { frames: tickFrames(2) }, scale: 0.85 };
    case 'scaffold':
      return { build: scaffold, bake: { frames: [() => undefined] }, scale: 1 };
    // The plinth under a three-cell building on terraced land (one slab per cell).
    case 'plinth':
      return { build: plinthModel, bake: { frames: [() => undefined] }, scale: 1 };
    case 'pile':
      return { build: () => pile(a as string), bake: { frames: [() => undefined] }, scale: 1 };
    case 'bp': {
      // Blueprint: the structure drawn in blue chalk light.
      const inner = recipe(`struct:${a}:${b}:${c}`);
      return {
        build: () => {
          const m = inner.build();
          m.root.traverse((o) => {
            const mesh = o as THREE.Mesh;
            if (mesh.isMesh) mesh.material = CHALK;
            if ((o as THREE.Sprite).isSprite) o.visible = false;
          });
          return m;
        },
        bake: { frames: [(m) => m.tick(0)] },
        scale: inner.scale,
      };
    }
    case 'proj':
      return { build: () => projectile(a as string), bake: { frames: [() => undefined] }, scale: 1 };
    default:
      return { build: rubble, bake: { frames: [() => undefined] }, scale: 1 };
  }
};

export const CHALK = new THREE.MeshBasicMaterial({ color: '#7fb8ff', transparent: true, opacity: 0.38, depthWrite: false });

const scaffold = (): Model => {
  const root = new THREE.Group();
  const wood = new THREE.MeshStandardMaterial({ color: '#7a5634', roughness: 0.9 });
  const rope = new THREE.MeshStandardMaterial({ color: '#a58a5a', roughness: 1 });
  const add = (g: THREE.BufferGeometry, m: THREE.Material, x: number, y: number, z: number, rx = 0, rz = 0): void => {
    const mesh = new THREE.Mesh(g, m);
    mesh.position.set(x, y, z);
    mesh.rotation.set(rx, 0, rz);
    root.add(mesh);
  };
  const H = 1.25;
  for (const [x, z] of [[-0.42, -0.42], [0.42, -0.42], [0.42, 0.42], [-0.42, 0.42]] as const) add(new THREE.CylinderGeometry(0.025, 0.03, H, 5), wood, x, H / 2, z);
  for (const y of [0.45, 0.9]) {
    for (const z of [-0.42, 0.42]) add(new THREE.BoxGeometry(0.9, 0.03, 0.04), wood, 0, y, z);
    for (const x of [-0.42, 0.42]) add(new THREE.BoxGeometry(0.04, 0.03, 0.9), wood, x, y, 0);
    add(new THREE.BoxGeometry(0.88, 0.02, 0.22), wood, 0, y + 0.02, 0.32);
  }
  add(new THREE.CylinderGeometry(0.012, 0.012, 1.2, 4), rope, 0, 0.55, -0.42, 0, 0.75);
  add(new THREE.CylinderGeometry(0.012, 0.012, 1.2, 4), rope, 0.42, 0.55, 0, 0.75, 0);
  // A stack of ashlars and a few logs at the foot.
  const stoneM = new THREE.MeshStandardMaterial({ color: '#8b857a', roughness: 0.95, flatShading: true });
  for (let i = 0; i < 3; i++) add(new THREE.BoxGeometry(0.16, 0.1, 0.12), stoneM, 0.55, 0.05 + i * 0.1, -0.1 + (i % 2) * 0.05);
  for (let i = 0; i < 2; i++) add(new THREE.CylinderGeometry(0.04, 0.04, 0.5, 6), wood, -0.6, 0.04 + i * 0.07, 0.1, 0, Math.PI / 2);
  return { root, tick: () => undefined, height: H };
};

/** Incursion objectives: what is being extracted at the clearing's heart. */
const nodePiece = (place: string): Model => {
  // A warlord's den is a dark altar: the same brazier and dust.
  const kind = place === 'lair' ? 'altar' : place;
  if (kind === 'altar') return items.relic({ id: 'brazier' });
  if (kind === 'iron') return e2.ironMine({});
  if (kind === 'fort') return fort.sapperFort({});
  if (kind === 'rescue') {
    const g = heroes.golem({ variant: 2 });
    g.root.scale.setScalar(1.6);
    return g;
  }
  const root = new THREE.Group();
  const add = (geo: THREE.BufferGeometry, mat: THREE.Material, x: number, y: number, z: number, rx = 0, ry = 0, rz = 0): void => {
    const m = new THREE.Mesh(geo, mat);
    m.position.set(x, y, z);
    m.rotation.set(rx, ry, rz);
    root.add(m);
  };
  const ground = new THREE.MeshStandardMaterial({ color: '#3a3226', roughness: 1, flatShading: true });
  add(new THREE.CylinderGeometry(0.62, 0.7, 0.1, 8), ground, 0, 0.05, 0);
  if (kind === 'quarry') {
    const st = new THREE.MeshStandardMaterial({ color: '#8b857a', roughness: 0.95, flatShading: true });
    for (let i = 0; i < 9; i++) add(new THREE.BoxGeometry(0.26, 0.16, 0.18), st, ((i % 3) - 1) * 0.28, 0.18 + Math.floor(i / 3) * 0.17, (i % 2) * 0.1 - 0.05, 0, i * 0.3, 0);
    add(new THREE.DodecahedronGeometry(0.35, 0), st, 0.35, 0.3, -0.3);
  } else if (kind === 'forest') {
    const bark = new THREE.MeshStandardMaterial({ color: '#5b3d26', roughness: 0.9 });
    const cut = new THREE.MeshStandardMaterial({ color: '#c79a62', roughness: 0.9 });
    for (let i = 0; i < 6; i++) {
      add(new THREE.CylinderGeometry(0.08, 0.08, 0.9, 8), bark, -0.3 + (i % 3) * 0.2, 0.18 + Math.floor(i / 3) * 0.15, 0, 0, 0, Math.PI / 2);
    }
    add(new THREE.CylinderGeometry(0.2, 0.24, 0.3, 10), bark, 0.4, 0.25, 0.3);
    add(new THREE.CircleGeometry(0.2, 10), cut, 0.4, 0.41, 0.3, -Math.PI / 2);
  } else {
    const cr = new THREE.MeshStandardMaterial({ color: '#8fd3ff', emissive: '#2c7fd0', emissiveIntensity: 0.9, roughness: 0.15, flatShading: true, transparent: true, opacity: 0.9 });
    for (let i = 0; i < 6; i++) {
      const a = (i / 6) * Math.PI * 2;
      add(new THREE.OctahedronGeometry(0.14, 0).scale(1, 3 + (i % 3), 1), cr, Math.cos(a) * 0.25, 0.4, Math.sin(a) * 0.25, Math.cos(a) * 0.3, 0, Math.sin(a) * 0.3);
    }
    add(new THREE.OctahedronGeometry(0.2, 0).scale(1, 4.5, 1), cr, 0, 0.7, 0);
  }
  return { root, tick: () => undefined, height: 1.2 };
};

/** What an incursion has extracted so far, stacked beside the node (scaled with progress). */
const pile = (place: string): Model => {
  const kind = place === 'lair' ? 'altar' : place;
  if (kind === 'iron') return e2.orePile({});
  if (kind === 'fort') return fort.dustSpoil({});
  // Not a node's: the hole a sapper goes down and the ridge its tunnel heaves up.
  if (kind === 'mound') return fort.dirtMound({});
  if (kind === 'ridge') return fort.dirtRidge({});
  const root = new THREE.Group();
  const add = (geo: THREE.BufferGeometry, mat: THREE.Material, x: number, y: number, z: number, rx = 0, ry = 0, rz = 0): void => {
    const m = new THREE.Mesh(geo, mat);
    m.position.set(x, y, z);
    m.rotation.set(rx, ry, rz);
    root.add(m);
  };
  const wood = new THREE.MeshStandardMaterial({ color: '#7a5634', roughness: 0.9 });
  const cut = new THREE.MeshStandardMaterial({ color: '#d2a46c', roughness: 0.9 });
  const stoneM = new THREE.MeshStandardMaterial({ color: '#a39d92', roughness: 0.95, flatShading: true });
  const logs = (x: number, z: number): void => {
    // A pyramid of logs, cut ends facing out.
    for (const [row, n] of [[0, 3], [1, 2], [2, 1]] as const) {
      for (let i = 0; i < n; i++) {
        const lx = x + (i - (n - 1) / 2) * 0.17;
        const ly = 0.08 + row * 0.14;
        add(new THREE.CylinderGeometry(0.08, 0.08, 0.62, 8), wood, lx, ly, z, Math.PI / 2, 0, 0);
        add(new THREE.CircleGeometry(0.075, 8), cut, lx, ly, z + 0.315);
      }
    }
  };
  const blocks = (x: number, z: number): void => {
    for (let i = 0; i < 7; i++) {
      const row = i < 4 ? 0 : i < 6 ? 1 : 2;
      const col = i < 4 ? i : i < 6 ? i - 4 : 0;
      const n = row === 0 ? 4 : row === 1 ? 2 : 1;
      add(new THREE.BoxGeometry(0.17, 0.12, 0.22), stoneM, x + (col - (n - 1) / 2) * 0.19, 0.06 + row * 0.125, z, 0, (i % 3) * 0.08, 0);
    }
  };
  if (kind === 'forest') logs(0, 0);
  else if (kind === 'quarry') blocks(0, 0);
  else if (kind === 'crystal') {
    add(new THREE.BoxGeometry(0.5, 0.26, 0.36), wood, 0, 0.13, 0);
    const cr = new THREE.MeshStandardMaterial({ color: '#8fd3ff', emissive: '#2c7fd0', emissiveIntensity: 0.9, roughness: 0.15, flatShading: true });
    for (let i = 0; i < 7; i++) add(new THREE.OctahedronGeometry(0.06, 0).scale(1, 2.6, 1), cr, -0.18 + (i % 4) * 0.12, 0.33, -0.08 + Math.floor(i / 4) * 0.15, (i % 3) * 0.3 - 0.3, 0, (i % 2) * 0.4 - 0.2);
  } else if (kind === 'altar') {
    const urn = new THREE.MeshStandardMaterial({ color: '#3d3550', roughness: 0.6 });
    const dust = new THREE.MeshStandardMaterial({ color: '#d7c8ff', emissive: '#8e6bff', emissiveIntensity: 1.1, roughness: 0.4 });
    for (const [x, z] of [[-0.14, 0], [0.16, 0.05], [0.02, -0.17]] as const) {
      add(new THREE.CylinderGeometry(0.09, 0.07, 0.24, 8), urn, x, 0.12, z);
      add(new THREE.SphereGeometry(0.075, 8, 6), dust, x, 0.25, z);
    }
  } else {
    logs(-0.22, 0);
    blocks(0.3, 0.1);
  }
  return { root, tick: () => undefined, height: 0.4 };
};

const rubble = (): Model => {
  const root = new THREE.Group();
  const mat = new THREE.MeshStandardMaterial({ color: '#5a554d', roughness: 1, flatShading: true });
  const dark = new THREE.MeshStandardMaterial({ color: '#2a2622', roughness: 1, flatShading: true });
  const base = new THREE.Mesh(new THREE.CylinderGeometry(0.42, 0.5, 0.08, 7), dark);
  base.position.y = 0.04;
  root.add(base);
  const pts = [
    [0.1, 0.2, 0.14],
    [-0.18, 0.1, 0.12],
    [0.22, -0.15, 0.1],
    [-0.1, -0.2, 0.16],
    [0, 0, 0.2],
    [0.3, 0.1, 0.08],
  ];
  for (const [x, z, s] of pts) {
    const r = new THREE.Mesh(new THREE.DodecahedronGeometry(s as number, 0), mat);
    r.position.set(x as number, (s as number) * 0.6, z as number);
    r.rotation.set(x as number, z as number, s as number);
    root.add(r);
  }
  return { root, tick: () => undefined, height: 0.3 };
};

const PROJ_MATS = {
  wood: new THREE.MeshStandardMaterial({ color: '#5b3d26', roughness: 0.8 }),
  steel: new THREE.MeshStandardMaterial({ color: '#4a4f57', metalness: 0.8, roughness: 0.35 }),
  rock: new THREE.MeshStandardMaterial({ color: '#6d6559', roughness: 1, flatShading: true }),
  brass: new THREE.MeshStandardMaterial({ color: '#b08a3e', metalness: 0.8, roughness: 0.4 }),
  fletch: new THREE.MeshStandardMaterial({ color: '#8a2a2a', roughness: 0.9 }),
  copper: new THREE.MeshStandardMaterial({ color: '#a4512f', metalness: 0.8, roughness: 0.4 }),
  basalt: new THREE.MeshStandardMaterial({ color: '#1e1a19', roughness: 0.95, flatShading: true }),
  molten: new THREE.MeshStandardMaterial({ color: '#ff8a3d', emissive: '#ff4a12', emissiveIntensity: 1.8, roughness: 0.6, flatShading: true }),
  obsidian: new THREE.MeshStandardMaterial({ color: '#0d0b12', roughness: 0.12, metalness: 0.4, flatShading: true }),
  glint: new THREE.MeshStandardMaterial({ color: '#d9ccff', emissive: '#8a5cff', emissiveIntensity: 1.4, roughness: 0.3, flatShading: true }),
  /** The whistling ballista's reed shaft and bone whistle (models/branches.ts whistler). */
  reed: new THREE.MeshStandardMaterial({ color: '#aeb5a2', roughness: 0.8 }),
  horn: new THREE.MeshStandardMaterial({ color: '#d5d8d1', roughness: 0.6 }),
  lime: new THREE.MeshStandardMaterial({ color: '#cfd2cb', roughness: 1, flatShading: true }),
};

const projectile = (kind: string): Model => {
  const root = new THREE.Group();
  const add = (g: THREE.BufferGeometry, m: THREE.Material, z = 0): void => {
    const mesh = new THREE.Mesh(g, m);
    mesh.position.z = z;
    root.add(mesh);
  };
  if (kind === 'rock') add(new THREE.DodecahedronGeometry(0.11, 0), PROJ_MATS.rock);
  else if (kind === 'boulder') {
    // The trebuchet's stone: a great rough boulder, a smaller lump fused to it.
    add(new THREE.DodecahedronGeometry(0.2, 0), PROJ_MATS.rock);
    const lump = new THREE.Mesh(new THREE.DodecahedronGeometry(0.1, 0), PROJ_MATS.basalt);
    lump.position.set(0.12, 0.08, -0.05);
    root.add(lump);
  } else if (kind === 'cinder') {
    // A lump of molten rock (eruptions, the magma lord): black crust split open on fire.
    add(new THREE.DodecahedronGeometry(0.08, 0), PROJ_MATS.basalt);
    const hot = new THREE.Mesh(new THREE.IcosahedronGeometry(0.062, 0), PROJ_MATS.molten);
    hot.position.set(0.025, 0.02, 0.015);
    root.add(hot);
  } else if (kind === 'glassShard') {
    // A splinter of black glass (the colossus's slam, a pit giving way): a long sharp shard with a lit edge.
    const sh = new THREE.Mesh(new THREE.OctahedronGeometry(0.07, 0), PROJ_MATS.obsidian);
    sh.scale.set(0.55, 1.6, 0.35);
    root.add(sh);
    const edge = new THREE.Mesh(new THREE.OctahedronGeometry(0.025, 0), PROJ_MATS.glint);
    edge.scale.set(0.5, 3.2, 0.5);
    edge.position.x = 0.02;
    root.add(edge);
  } else if (kind === 'dart') {
    // The clockwork turret's bolt: short, all steel, copper-fletched.
    add(new THREE.CylinderGeometry(0.012, 0.012, 0.3, 5).rotateX(Math.PI / 2), PROJ_MATS.steel);
    add(new THREE.ConeGeometry(0.025, 0.08, 5).rotateX(Math.PI / 2), PROJ_MATS.steel, 0.18);
    add(new THREE.BoxGeometry(0.05, 0.003, 0.06), PROJ_MATS.copper, -0.13);
    add(new THREE.BoxGeometry(0.003, 0.05, 0.06), PROJ_MATS.copper, -0.13);
  } else if (kind === 'harpoon') {
    // The harpoon ballista's shot: a long iron shaft, a broad barbed head, a tail of rope.
    add(new THREE.CylinderGeometry(0.022, 0.022, 0.8, 5).rotateX(Math.PI / 2), PROJ_MATS.steel);
    add(new THREE.ConeGeometry(0.06, 0.18, 5).rotateX(Math.PI / 2), PROJ_MATS.steel, 0.48);
    for (const k of [-1, 1]) {
      const barb = new THREE.Mesh(new THREE.ConeGeometry(0.02, 0.12, 4), PROJ_MATS.steel);
      barb.rotation.set(-Math.PI / 2, 0, k * -0.6);
      barb.position.set(k * 0.05, 0, 0.36);
      root.add(barb);
    }
    add(new THREE.CylinderGeometry(0.008, 0.008, 0.3, 4).rotateX(Math.PI / 2), PROJ_MATS.fletch, -0.52);
  } else if (kind === 'pitchPot' || kind === 'emberPot') {
    // A pot of burning pitch (catapult) or of embers (trebuchet): black iron, the fire showing at its mouth.
    const r = kind === 'emberPot' ? 0.12 : 0.09;
    add(new THREE.CylinderGeometry(r, r * 0.75, r * 1.3, 7), PROJ_MATS.basalt);
    const hot = new THREE.Mesh(new THREE.IcosahedronGeometry(r * 0.7, 0), PROJ_MATS.molten);
    hot.position.y = r * 0.55;
    root.add(hot);
  } else if (kind === 'splitStone') {
    // The trebuchet's split stone: a great boulder cracked in three, its seams glowing.
    for (let i = 0; i < 3; i++) {
      const a = (i / 3) * Math.PI * 2;
      const ch = new THREE.Mesh(new THREE.DodecahedronGeometry(0.13, 0), PROJ_MATS.rock);
      ch.position.set(Math.sin(a) * 0.09, Math.cos(a) * 0.09, 0);
      root.add(ch);
    }
    add(new THREE.IcosahedronGeometry(0.09, 0), PROJ_MATS.molten);
  } else if (kind === 'limeSack') {
    // The lime catapult's shot: a pale sack of quicklime, tied at the neck, dusting as it flies.
    add(new THREE.DodecahedronGeometry(0.12, 0).scale(1, 0.85, 1), PROJ_MATS.lime);
    add(new THREE.CylinderGeometry(0.03, 0.05, 0.06, 6).translate(0, 0.11, 0), PROJ_MATS.lime);
  } else if (kind === 'whistleBolt') {
    // The whistling ballista's bolt: a pale reed shaft, a bone whistle bulb behind the head, reed fletching.
    add(new THREE.CylinderGeometry(0.016, 0.016, 0.5, 5).rotateX(Math.PI / 2), PROJ_MATS.reed);
    add(new THREE.SphereGeometry(0.04, 6, 4).scale(1, 1, 1.6), PROJ_MATS.horn, 0.16);
    add(new THREE.ConeGeometry(0.03, 0.09, 5).rotateX(Math.PI / 2), PROJ_MATS.steel, 0.28);
    add(new THREE.BoxGeometry(0.06, 0.003, 0.08), PROJ_MATS.reed, -0.2);
    add(new THREE.BoxGeometry(0.003, 0.06, 0.08), PROJ_MATS.reed, -0.2);
  } else if (kind === 'bolt') {
    add(new THREE.CylinderGeometry(0.018, 0.018, 0.5, 5).rotateX(Math.PI / 2), PROJ_MATS.wood);
    add(new THREE.ConeGeometry(0.035, 0.1, 5).rotateX(Math.PI / 2), PROJ_MATS.steel, 0.28);
  } else if (kind === 'arrow') {
    add(new THREE.CylinderGeometry(0.008, 0.008, 0.42, 4).rotateX(Math.PI / 2), PROJ_MATS.wood);
    add(new THREE.ConeGeometry(0.018, 0.06, 4).rotateX(Math.PI / 2), PROJ_MATS.steel, 0.22);
    add(new THREE.BoxGeometry(0.04, 0.002, 0.07), PROJ_MATS.fletch, -0.18);
  } else {
    add(new THREE.SphereGeometry(0.04, 6, 4), PROJ_MATS.brass);
  }
  return { root, tick: () => undefined, height: 0.1 };
};

/** How much bigger than a boss the dragon stands (×SCALE.boss). */
const DRAGON_SCALE = 1.05;

/** Library key of a saga person's portrait miniature (Maelis is the Ash Witch). */
export const npcKey = (id: NpcId): string => `npc:${id}`;

/** Library key of a unique piece's miniature (its card picture). */
export const uniqueKey = (id: UniqueId): string => `unique:${id}`;

/** Library key of a gear piece's miniature (its card picture): its base and rarity. */
export const gearKey = (base: GearBaseId, rarity: GearRarity): string => `gear:${base}:${rarity}`;

/** Library key of a hero miniature: its class, whether it's a sleeping player's spectre, and its level tier. */
/** A hero's model: class, spectre or not, tier, and what it wears (heroLook; none: the class's usual kit). */
export const heroKey = (cls: HeroClass | 'bear', level?: number, ghost = false, look?: string): string =>
  `hero:${cls}:${ghost ? 1 : 0}:${heroTier(level)}${look && cls !== 'bear' ? `:${look}` : ''}`;

/** Baked models are global: every view and thumbnail shares the GPU geometry. */
const BAKED = new Map<string, { baked: BakedModel; scale: number }>();

export const baked = (key: string): { baked: BakedModel; scale: number } => {
  let b = BAKED.get(key);
  if (!b) {
    b = bakeFresh(key, null);
    BAKED.set(key, b);
  }
  return b;
};

/** Whether `key` is baked already (here, not in the bake worker). */
export const isBaked = (key: string): boolean => BAKED.has(key);

/**
 * Builds and bakes `key`. With `mats`, each frame's materials are listed as it is taken (collectMaterials): the
 * order adoptBaked meets them in when it rebuilds the model on the other side.
 */
export const bakeFresh = (key: string, mats: THREE.Material[] | null): { baked: BakedModel; scale: number } => {
  const r = recipe(key);
  const m = r.build();
  const spec = r.rig?.(m) ?? null;
  const seen = new Set<THREE.Material>();
  const frames = mats ? r.bake.frames.map((f) => (x: ModelLike): void => (f(x), collectMaterials(x.root, mats, seen))) : r.bake.frames;
  const opts: BakeOptions = { ...r.bake, frames, ...(spec ? { skin: { bones: spec.skel.bones, anim: bakeAnim(spec.key, m.root, spec.skel.bones, spec.skel.names, spec.clips) } } : {}) };
  return { baked: bakeModel(key, m, opts), scale: r.scale };
};

/** The bake worker's side: `key` baked as plain data (see bake-wire.ts). */
export const bakeToWire = (key: string): { wire: ModelWire; transfer: ArrayBuffer[] } => {
  const mats: THREE.Material[] = [];
  return toWire(bakeFresh(key, mats).baked, mats);
};

/**
 * Takes in `key` baked by the worker. The model is built again here only for its materials, met in the same
 * order (building is the cheap part: sampling the clips and merging the geometry stayed in the worker).
 */
export const adoptBaked = (key: string, w: ModelWire): void => {
  if (BAKED.has(key)) return;
  const r = recipe(key);
  const m = r.build();
  r.rig?.(m);
  const mats: THREE.Material[] = [];
  const seen = new Set<THREE.Material>();
  for (const f of r.bake.frames) {
    f(m);
    collectMaterials(m.root, mats, seen);
  }
  BAKED.set(key, { baked: fromWire(w, mats), scale: r.scale });
};

/** Per-view set of instanced batches. */
export class Library {
  readonly group = new THREE.Group();
  private batches = new Map<string, ModelBatch>();

  constructor(private glow: GlowLayer) {
    this.group.name = 'library';
  }

  /** `far`: the model's far version (engine/lod.ts), or the full one until it can be made. */
  batch(key: string, far = false): ModelBatch {
    if (far) {
      let b = this.batches.get(`${key}@far`);
      if (!b) {
        const m = farModel(baked(key).baked);
        if (!m) return this.batch(key);
        b = new ModelBatch(m, this.glow, key.includes('enemy:') ? 32 : 8);
        this.batches.set(`${key}@far`, b);
        this.group.add(b.group);
      }
      return b;
    }
    let b = this.batches.get(key);
    if (!b) {
      b = new ModelBatch(baked(key).baked, this.glow, key.includes('enemy:') ? 32 : 8);
      this.batches.set(key, b);
      this.group.add(b.group);
    }
    return b;
  }

  /** Has `key`'s far version made ahead (in the LOD worker), so a crowd seen small draws it from its first frame. */
  farAhead(key: string): void {
    if (LOD.on) farModel(baked(key).baked);
  }

  scaleOf(key: string): number {
    return baked(key).scale;
  }

  heightOf(key: string): number {
    return baked(key).baked.height;
  }

  /** Frame index of a guard automaton pose (`bot:guard`). */
  guardFrame(p: GuardPose): number {
    return Math.max(0, GUARD_POSES.indexOf(p));
  }

  /** Frame index of a clockwork bot pose (`bot:automaton|colossus`). */
  botFrame(p: clock.BotPose): number {
    return Math.max(0, clock.BOT_POSES.indexOf(p));
  }

  poseFrame(p: Pose): number {
    const i = POSES.indexOf(p);
    return i < 0 ? 0 : i;
  }

  /** A plain group of frame-0 meshes with a single override material (build preview). */
  ghostOf(key: string, mat: THREE.Material): THREE.Group {
    const g = new THREE.Group();
    const b = baked(key).baked;
    for (const p of b.frames[0]?.parts ?? []) g.add(new THREE.Mesh(p.geometry, mat));
    for (const d of b.dynamic) {
      const sub = new THREE.Group();
      sub.applyMatrix4(d.base);
      for (const p of d.frame.parts) sub.add(new THREE.Mesh(p.geometry, mat));
      g.add(sub);
    }
    return g;
  }

  /** Batches drawn once ahead (ModelBatch.warm), and the one drawing an empty instance this frame. */
  private warmed = new Set<string>();
  private warming: ModelBatch | null = null;

  /** Every mesh of every batch, for compiling them ahead one by one. */
  meshes(): THREE.Object3D[] {
    const out: THREE.Object3D[] = [];
    for (const b of this.batches.values()) b.group.traverse((o) => (o as THREE.Mesh).isMesh && out.push(o));
    return out;
  }

  /**
   * Each frame, the next batch not drawn yet draws an empty instance (and last frame's goes back), one per frame
   * so the uploads spread out. False once every batch has had its turn.
   */
  warmNext(): boolean {
    this.warming?.cool();
    this.warming = null;
    for (const [k, b] of this.batches) {
      if (this.warmed.has(k)) continue;
      this.warmed.add(k);
      b.warm();
      this.warming = b;
      return true;
    }
    return false;
  }

  drawCalls(): number {
    let n = 0;
    for (const b of this.batches.values()) n += b.drawCalls();
    return n;
  }
}

/**
 * A saga person's portrait as a transparent PNG data URL: head and shoulders, a little from the side, as
 * the scene dialogs show it (`renderThumb` frames the whole figure).
 */
export const renderPortrait = (renderer: THREE.WebGLRenderer, id: NpcId, size = 128): string => renderThumb(renderer, npcKey(id), size, 0, { bust: true });

/**
 * A card's scene: its own lights and the model's meshes at one frame. `own` draws copies of the geometry, to be freed
 * once drawn: the shared one may be on screen (freeing it would leave the view's animated batches bound to a deleted buffer).
 */
const cardScene = (b: BakedModel, frame: number, own = false): { scene: THREE.Scene; g: THREE.Group } => {
  const scene = new THREE.Scene();
  // Cards are small: light them brighter than the table (render targets skip tone mapping) with a front fill.
  scene.add(new THREE.HemisphereLight(0xe2dcd2, 0x4a4036, 2.8));
  const k = new THREE.DirectionalLight(0xffe0b8, 4.4);
  k.position.set(-3, 5, 4);
  const fill = new THREE.DirectionalLight(0xdfe6ff, 1.8);
  fill.position.set(3, 1.5, 5);
  const rim = new THREE.DirectionalLight(0x9fb4ff, 2.2);
  rim.position.set(4, 3, -4);
  scene.add(k, fill, rim);
  const g = new THREE.Group();
  const fr = b.frames[frame] ?? b.frames[0];
  const geo = (x: THREE.BufferGeometry): THREE.BufferGeometry => (own ? x.clone() : x);
  for (const p of fr?.parts ?? []) g.add(new THREE.Mesh(geo(p.geometry), p.material));
  for (const d of b.dynamic) {
    const sub = new THREE.Group();
    sub.applyMatrix4(d.base);
    for (const p of d.frame.parts) sub.add(new THREE.Mesh(geo(p.geometry), p.material));
    g.add(sub);
  }
  scene.add(g);
  return { scene, g };
};

let cardTarget: THREE.WebGLRenderTarget | null = null;

/**
 * Compiles the shaders a model's card will draw with (its own lights, into a target without tone mapping: other
 * programs than the table's), in the driver's own thread where KHR_parallel_shader_compile exists. Settles once
 * they are linked: the first card drawn then compiles nothing on the spot (7 programs, up to a second on a
 * phone, when the hero sheet first showed the group's heroes).
 */
export const compileThumb = (renderer: THREE.WebGLRenderer, key: string): Promise<unknown> => {
  const { scene } = cardScene(baked(key).baked, 0);
  cardTarget ??= new THREE.WebGLRenderTarget(1, 1);
  const prev = renderer.getRenderTarget();
  renderer.setRenderTarget(cardTarget);
  const done = renderer.compileAsync(scene, new THREE.PerspectiveCamera()).catch(() => undefined);
  renderer.setRenderTarget(prev);
  return done;
};

/** The smallest framing radius of a gear weapon's card: about a two-handed weapon's own. */
const GEAR_WEAPON_FRAME = 0.5;

/** Draws a model's card into a target of its own and returns it (still holding the picture, unread). */
const drawCard = (renderer: THREE.WebGLRenderer, key: string, size: number, frame: number, o?: { bust?: boolean; yaw?: number; face?: boolean }): THREE.WebGLRenderTarget => {
  const { baked: b } = baked(key);
  const { scene, g } = cardScene(b, frame, true);
  const fr = b.frames[frame] ?? b.frames[0];
  // `yaw` turns the model toward the camera: the gear sheet shows its hero three-quarters front, both hands in view.
  g.rotation.y = o?.yaw ?? -0.6;
  const box = new THREE.Box3().setFromObject(g);
  if (o?.bust) {
    // Head and shoulders: the top of the figure, turned a little toward the viewer. `face`: closer, the face filling
    // a speaker's small round portrait (what they carry on their backs or hold up kept out of the framing).
    g.rotation.y = o.face ? -0.18 : -0.3;
    box.setFromObject(g);
    const tall = box.max.y - box.min.y;
    if (o.face) {
      // The head sits about 0.9 of the way up a standing figure (hats and staffs reach higher: framed from the head).
      const head = box.min.y + tall * 0.9;
      box.min.set(box.min.x, head - tall * 0.17, box.min.z);
      box.max.y = head + tall * 0.11;
      const c = box.getCenter(new THREE.Vector3());
      box.min.x = c.x - tall * 0.16;
      box.max.x = c.x + tall * 0.16;
    } else box.min.y = box.max.y - tall * 0.36;
  }
  const center = box.getCenter(new THREE.Vector3());
  const sz = box.getSize(new THREE.Vector3());
  let radius = o?.bust ? Math.max(sz.y, sz.x * 0.75) * (o.face ? 0.56 : 0.6) : Math.max(sz.x, sz.y, sz.z) * 0.54;
  // Gear weapons share one frame so a two-handed weapon reads bigger than a one-handed one.
  if (key.startsWith('gear:') && GEAR_BASES[key.split(':')[1] as GearBaseId]?.slot === 'weapon') radius = Math.max(radius, GEAR_WEAPON_FRAME);
  const cam = new THREE.PerspectiveCamera(30, 1, 0.05, 100);
  const dir = (o?.bust ? new THREE.Vector3(0.25, 0.12, 1) : new THREE.Vector3(0.62, 0.42, 0.78)).normalize();
  cam.position.copy(center).addScaledVector(dir, radius / Math.tan((15 * Math.PI) / 180));
  cam.lookAt(center);
  // The unique pieces' red glow is part of how they read: draw the model's glows on their cards.
  // (Added once the framing is set: the glows don't count toward it.)
  if (key.startsWith('unique:') || (key.startsWith('gear:') && /:(rare|veryRare|unique)$/.test(key))) {
    for (const gl of fr?.glows ?? []) {
      const sp = new THREE.Sprite(glowMat(`#${gl.color.getHexString()}`, gl.opacity, true));
      sp.position.copy(gl.pos);
      sp.scale.setScalar(gl.size);
      g.add(sp);
    }
  }
  const rt = new THREE.WebGLRenderTarget(size, size, { samples: 4 });
  rt.texture.colorSpace = THREE.SRGBColorSpace;
  const prevTarget = renderer.getRenderTarget();
  const prevClear = renderer.getClearColor(new THREE.Color());
  const prevAlpha = renderer.getClearAlpha();
  renderer.setRenderTarget(rt);
  renderer.setClearColor(0x000000, 0);
  renderer.clear();
  renderer.render(scene, cam);
  renderer.setRenderTarget(prevTarget);
  renderer.setClearColor(prevClear, prevAlpha);
  // The card's own copies leave the GPU with it: drawing the shared geometry kept every piece and look ever shown
  // on a card there until the page reloaded.
  g.traverse((o) => {
    if ((o as THREE.Sprite).isSprite) ((o as THREE.Sprite).material as THREE.Material).dispose();
    else (o as THREE.Mesh).geometry?.dispose();
  });
  return rt;
};

/** A card's pixels (bottom row first, as WebGL reads them) as a PNG data URL. */
const cardUrl = (px: Uint8Array, size: number): string => {
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = size;
  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
  const img = ctx.createImageData(size, size);
  // Flip Y and un-premultiply is not needed (straight alpha in RT).
  for (let y = 0; y < size; y++) {
    const src = (size - 1 - y) * size * 4;
    img.data.set(px.subarray(src, src + size * 4), y * size * 4);
  }
  ctx.putImageData(img, 0, 0);
  return canvas.toDataURL('image/png');
};

/** Renders a model to a transparent PNG data URL (cards, portraits). `bust` frames only the head and shoulders. */
export const renderThumb = (renderer: THREE.WebGLRenderer, key: string, size = 128, frame = 0, o?: { bust?: boolean; yaw?: number; face?: boolean }): string => {
  const rt = drawCard(renderer, key, size, frame, o);
  const px = new Uint8Array(size * size * 4);
  renderer.readRenderTargetPixels(rt, 0, 0, size, size, px);
  rt.dispose();
  return cardUrl(px, size);
};

/**
 * The same card, its pixels read back without waiting on the GPU: a plain read waits until the GPU has drawn
 * everything queued before it, the board's frame included, so on a phone bound by its GPU each card held a frame
 * 150–350 ms (prod, Adreno 610/618 and Mali-G77: rows of such frames on opening the hero sheet). This one copies
 * into a buffer, fences, and takes the pixels once the GPU passed the fence.
 */
export const renderThumbAsync = async (renderer: THREE.WebGLRenderer, key: string, size = 128, frame = 0, o?: { bust?: boolean; yaw?: number; face?: boolean }): Promise<string> => {
  const rt = drawCard(renderer, key, size, frame, o);
  const px = new Uint8Array(size * size * 4);
  try {
    await renderer.readRenderTargetPixelsAsync(rt, 0, 0, size, size, px);
  } finally {
    rt.dispose();
  }
  return cardUrl(px, size);
};
